import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-bold",
  "use": "icon-check-bold-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-check-bold\"><path fill-rule=\"evenodd\" d=\"M8.115 19.748a1.792 1.792 0 002.917 0l11.883-16.53c.214-.3 0-.718-.367-.718h-2.646c-.576 0-1.123.277-1.462.753l-8.863 12.34-4.017-5.592a1.803 1.803 0 00-1.462-.753H1.452a.455.455 0 00-.367.719l7.03 9.781z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol